

























import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";

@Component
export default class Attention extends Vue {
  private isOpen = false;

  openDialog() {
    this.isOpen = true;
  }

  @Emit()
  private attention() {
    return;
  }
}
